import * as React from 'react';

import { TravelerForgotPasswordFormValues } from '../../types/travelerProfileForm';
import { FormErrors, AddToast } from '../../types/airframe';
import styles from './travelerForgotCard.module.css';

import {
  Button,
  Flex,
  Form,
  TextField,
  TextInput,
  ToastConsumer,
} from '@flightstats/airframe-react';

import { FormResponseError } from '../../components/cirium/FormResponseError';
import { CiriumCard } from '../../components/cards/CiriumCard';
import { HoneypotInput } from '../../components/forms/HoneypotInput';

type TravelerForgotCardProps = {
  handleForgotPassword: (
    errors: FormErrors,
    values: TravelerForgotPasswordFormValues,
    addToast: AddToast,
  ) => void;
  loading: boolean;
  showError: boolean;
};

export const TravelerForgotCard: React.FC<TravelerForgotCardProps> = ({
  handleForgotPassword,
  loading,
  showError,
}) => {
  const [email, setEmail] = React.useState('');
  const [confirmEmailError, setConfirmEmailError] = React.useState('');
  const [confirmError, setConfirmError] = React.useState(false);
  const [confirmEmail, setConfirmEmail] = React.useState('');
  return (
    <ToastConsumer>
      {({ addToast }) => (
        <CiriumCard
          title="Forgot Login"
          description="Trip Alert will email your username and a new password"
        >
          <Form
            onSubmit={(errors: FormErrors, values: TravelerForgotPasswordFormValues, e: any) => {
              e.event.preventDefault(); // Needed for submitOnEnter
              if(email !== confirmEmail) {
                setConfirmEmailError('Emails must match!');
                setConfirmError(true);
              } else {
                handleForgotPassword(errors, values, addToast);
              }
            }}
            submitOnEnter
          >
            {showError && (
              <FormResponseError message="Could not find an associated email" />
            )}
            <TextField name="email">
              <TextInput
                autoFocus
                type="email"
                id="email"
                label="email"
                disabled={loading}
                onChange={(value) => setEmail(value)}
              />
            </TextField>

            <TextField name="confirmEmail">
              <TextInput
                type="email"
                label="Confirm Email"
                disabled={loading}
                onChange={(value) => {setConfirmEmail(value); setConfirmError(false);}}
              />
            </TextField>
            {confirmError && (
              <div className={styles.forgotError}><span color="feedback.error">{confirmEmailError} </span></div>
            )}
            <HoneypotInput />

            <Flex className={styles.flexCenter}>
              <Button type="submit" disabled={loading}>
                RESET
              </Button>
            </Flex>
          </Form>
        </CiriumCard>
      )}
    </ToastConsumer>
  );
};